<template>
  <v-container style="max-width: 100%">
    <v-row no-gutters v-resize="onResize">
      <v-col>
        <v-card class="px-2 py-0" elevation="0">
          <h1>{{ $t("payments.title") }}</h1>
          <v-progress-linear
              indeterminate
              reverse
              v-show="!isFetchedSites || !isFetchedClientCatalogGroups"
              class="my-2"
          ></v-progress-linear>
          <v-container style="max-width: 100%; " class="px-0">
            <v-breadcrumbs
                class="px-0 py-0 my-0"
                :items="[
                {
                  text: $t('sites.title'),
                  disabled: false,
                  href: '/',
                },
                {
                  text: selectedSite && selectedSite.domain,
                  disabled: true,
                },
              ]"
                large
            ></v-breadcrumbs>
            <v-alert
                v-if="$route.params.payment_status === 'fail-payment'"
                border="left"
                close-text="Close Alert"
                color="error"
                dark
                dismissible
                @click="alertToggle"
            >
              {{ $t("payments.payment_failed") }}
            </v-alert>
            <v-alert
                v-if="$route.params.payment_status === 'success-payment'"
                border="left"
                close-text="Close Alert"
                color="success"
                dark
                dismissible
                @click="alertToggle"
            >
              {{ $t("payments.payment_success") }}
            </v-alert>
              <div ref="wrap" class="overflow-y-auto" :style="{height:wrapHeight+'px'}">
              <h2>{{ $t("payments.original_catalog_service") }}
                <v-btn class="success ml-2" @click="chooseAll('original')">
                  {{ $t("payments.select_all_with_discount") }}
                  <v-icon>{{isEnabledAllOriginal ? 'mdi-checkbox-marked-circle-outline' : 'mdi-checkbox-blank-circle-outline' }}</v-icon>
                </v-btn></h2>
              <v-container fluid>
                <v-row dense>
                  <v-col
                      v-for="clientCatalogGroup in clientCatalogGroups.filter(el=>!specialCatalogs.includes(el.group_id))"
                      :key="clientCatalogGroup.id"
                      :cols=" $vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
                      :class="{'px-0':$vuetify.breakpoint.smAndDown}"
                  >
                    <catalog-group-tile
                        :is-enabled-all-original="isEnabledAllOriginal"
                        :is-enabled-all-special="isEnabledAllSpecial"
                        :is-original="true"
                        :currency="totalCurrency"
                        :status="clientCatalogGroup.status"
                        :height="107"
                        v-if="groupsPayment"
                        :groups="clientCatalogGroup"
                        :group="groupsPayment[clientCatalogGroup.group_id]"
                        @change-enabling="groupsPayment[clientCatalogGroup.group_id].is_enabled = ! groupsPayment[clientCatalogGroup.group_id].is_enabled;calcPrices();"
                    />
                  </v-col>
                </v-row>
              </v-container>
              <h2>{{ $t("payments.special_catalog_service") }}
                <v-btn class="success ml-2" @click="chooseAll('special')">
                  {{ $t("payments.select_all_with_discount") }}
                  <v-icon>{{isEnabledAllSpecial ? 'mdi-checkbox-marked-circle-outline' : 'mdi-checkbox-blank-circle-outline' }}
                  </v-icon>
                </v-btn>
              </h2>
              <v-container fluid>
                <v-row dense>
                  <v-col
                      v-for="clientCatalogGroup in clientCatalogGroups.filter(el=>specialCatalogs.includes(el.group_id))"
                      :key="clientCatalogGroup.id"
                      :cols=" $vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
                  >
                    <catalog-group-tile
                        :is-special="true"
                        :is-enabled-all-special="isEnabledAllSpecial"
                        :currency="totalCurrency"
                        :status="clientCatalogGroup.status"
                        :height="147" v-if="groupsPayment"
                        :groups="clientCatalogGroup"
                        :group="groupsPayment[clientCatalogGroup.group_id]"
                        @change-enabling="groupsPayment[clientCatalogGroup.group_id].is_enabled = ! groupsPayment[clientCatalogGroup.group_id].is_enabled;calcPrices();"/>
                  </v-col>
                </v-row>
              </v-container>
              </div>
              <v-row class="mt-2 px-2" ref="payBlock">
                <v-col lg="8" md="6" cols="12" class="text-right ma-0 pa-0">
                  <div class="d-flex align-center justify-md-end">
                    <div class="d-flex text-no-wrap">
                      {{ $t("payments.payment_type") }}:
                    </div>
                    <v-radio-group
                        v-model="paymentType"
                        row
                        class="text-right d-flex mb-0"
                    >
                      <v-radio value="Tinkoff" v-if="client_lang === 'ru'">
                        <template v-slot:label>
                          <v-icon>mdi-credit-card</v-icon>
                          {{ $t("payments.card") }}
                        </template>
                      </v-radio>
                      <v-radio value="Arca" v-if="client_lang === 'en' && isArcaEnabled">
                        <template v-slot:label>
                          <v-icon>mdi-credit-card</v-icon>
                          {{ $t("payments.card") }}
                        </template>
                      </v-radio>
                      <v-radio value="Payproglobal" v-if="client_lang === 'en' && isPayProglobalEnabled">
                        <template v-slot:label>
                          <v-icon>mdi-credit-card</v-icon>
                          {{ $t("payments.card") }}
                        </template>
                      </v-radio>
                      <v-radio value="invoice">
                        <template v-slot:label>
                          <v-icon>mdi-file-document-outline</v-icon>
                          {{ $t("payments.invoice") }}
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
                <v-col lg="4" md="6" cols="12" class="pa-0 ma-0">
                  <div
                      class="d-flex align-center mr-2 justify-md-end"
                      v-if="isFetchedSites && isFetchedClientCatalogGroups"
                  >
                    <span
                        class="text-no-wrap d-flex align-center mr-2 justify-md-end"
                    >
                      <span class="d-inline-flex text-md-h5 text-sm-h6 text--primary "
                      >{{ $t("payments.total_sum") }}:
                        <v-icon class="d-inline-flex" color="success" v-if="totalCurrency === 'eur'">mdi-currency-eur</v-icon>
                        <span class="success--text">{{ totalSum.toFixed(0) }}</span>
                      </span
                      >
                      <v-icon class="d-inline-flex" color="success"  v-if="totalCurrency === 'rub'"
                      >mdi-currency-rub</v-icon
                      >
                      <span class="text-md-h5 text-sm-h6 text--primary pl-1">
                      {{$t('payments.per_month')}}
                        </span>
                    </span>
                    <v-btn
                        class="d-inline-flex"
                        color="success"
                        :x-large="$vuetify.breakpoint.mdAndUp"
                        :loading="isProcessingPayment"
                        :disabled="totalSum < 1 || isProcessingPayment"
                        @click="pay"
                    >{{ $t("payments.pay") }}</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <requisites-window
        :is-visible="requisitesWindow.isVisible"
        @hide="requisitesWindow.isVisible = false"
    />
  </v-container>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
import RequisitesWindow from "@/components/RequisitesWindow";
import CatalogGroupTile from "@/components/CatalogGroupTile"

export default {
  name: "Payments",
  components: {CatalogGroupTile, RequisitesWindow },
  data: () => ({
    specialCatalogs: [10, 7, 12],
    DISCOUNT_IF_ENABLED_ALL_ORIGINAL_CATALOGS: 0.529352941,
    DISCOUNT_IF_ENABLED_ALL_SPECIAL_CATALOGS: 0.714142857,
    groupsPayment: {},
    selectedSite: null,
    logoPath: process.env.VUE_APP_BRANDS_MINI_PATH,
    wrapHeight: 500,
    totalSum: 0,
    totalCurrency: null,
    paymentType: null,
    requisitesWindow: {
      isVisible: false,
    },
  }),
  mounted() {
    this.fetch();
  },
  computed: {
    isEnabledAllOriginal(){
      if(! this.isFetchedClientCatalogGroups) return false;
      let result = true;
      this.clientCatalogGroups.filter(el=>!this.specialCatalogs.includes(el.group_id)).forEach((clientCatalogGroup)=>{
        if( ! this.groupsPayment[clientCatalogGroup.group_id]) {
          result = false;
        } else {
          if (!this.groupsPayment[clientCatalogGroup.group_id].is_enabled) result = false;
        }
      })
      return result;
    },
    isEnabledAllSpecial(){
      if(! this.isFetchedClientCatalogGroups) return false;
      let result = true;
      this.clientCatalogGroups.filter(el=>this.specialCatalogs.includes(el.group_id)).forEach((clientCatalogGroup)=>{
        if( ! this.groupsPayment[clientCatalogGroup.group_id]) {
          result = false;
        } else {
          if (!this.groupsPayment[clientCatalogGroup.group_id].is_enabled) result = false;
        }
      })
      return result;
    },
    isPayProglobalEnabled(){
      return process.env.VUE_APP_IS_ENABLED_PAYPROGLOBAL_PAYMENTS && process.env.VUE_APP_IS_ENABLED_PAYPROGLOBAL_PAYMENTS.toLowerCase().trim()==='true';
    },
    isArcaEnabled(){
      return process.env.VUE_APP_IS_ENABLED_ARCA_PAYMENTS && process.env.VUE_APP_IS_ENABLED_ARCA_PAYMENTS.toLowerCase().trim()==='true';
    },
    ...mapFields("auth", ["requisites", "client_lang"]),
    ...mapFields("client_catalog_groups", [
      "isFetchedClientCatalogGroups",
      "clientCatalogGroups",
    ]),
    ...mapFields("payments", ["isProcessingPayment"]),
    ...mapFields("sites", [
      "nowProcessingSiteWithId",
      "sites",
      "savingInProgress",
      "isFetchedSites",
    ]),
  },
  watch: {
    selectedSite(site) {
      this.$store
          .dispatch("client_catalog_groups/fetch", { sait_code: site.sait_code })
          .then(() => {
            let tmpGroupsPayment = {};
            this.clientCatalogGroups.forEach((group) => {
              tmpGroupsPayment[group.group_id] = {};
              tmpGroupsPayment[group.group_id].group_id = group.group_id;
              tmpGroupsPayment[group.group_id].number_of_months = 0;
              tmpGroupsPayment[group.group_id].sum = 0;
              tmpGroupsPayment[group.group_id].is_disabled_footer = false;
              tmpGroupsPayment[group.group_id].is_enabled = false;

              let cost_index = "cost_1";
              if (this.$i18n.locale === "en") {
                this.totalCurrency = "eur";
                cost_index = cost_index + "_en";
              } else {
                this.totalCurrency = "rub";
              }

              tmpGroupsPayment[group.group_id].price_per_month = group.info[cost_index];
              if( ! this.specialCatalogs.includes(group.group_id)){
                tmpGroupsPayment[group.group_id].price_per_month_with_discount = tmpGroupsPayment[group.group_id].price_per_month*this.DISCOUNT_IF_ENABLED_ALL_ORIGINAL_CATALOGS
              } else {
                tmpGroupsPayment[group.group_id].price_per_month_with_discount = tmpGroupsPayment[group.group_id].price_per_month*this.DISCOUNT_IF_ENABLED_ALL_SPECIAL_CATALOGS
              }

            });
            this.groupsPayment = { ...tmpGroupsPayment };
            this.calcPrices();
            this.onResize();
          });
    },
  },
  methods: {
    chooseAll(type){

      if(type==='original'){
        let value = ! this.isEnabledAllOriginal;
        this.clientCatalogGroups.filter(el=>!this.specialCatalogs.includes(el.group_id)).forEach((clientCatalogGroup)=>{
          this.groupsPayment[clientCatalogGroup.group_id].is_enabled = value;
        })
      }
      if(type==='special'){
        let value = ! this.isEnabledAllSpecial;
        this.clientCatalogGroups.filter(el=>this.specialCatalogs.includes(el.group_id)).forEach((clientCatalogGroup)=>{
          this.groupsPayment[clientCatalogGroup.group_id].is_enabled = value;
        })
      }
      this.calcPrices()
    },
    async fetch() {
      return await this.$store.dispatch("sites/fetch").then(() => {
        if (this.sites) {
          this.selectedSite = this.sites.find(
              (site) => parseInt(site.id) === parseInt(this.$route.params.site_id)
          );
        }
      });
    },
    alertToggle() {
      this.fetch().then(() => {
        this.$router.push({
          name: "Payments",
          params: { site_id: this.selectedSite.id },
        });
      });
    },
    showRequisitesWindow() {
      this.requisitesWindow.isVisible = true;
    },
    pay() {
      if (!this.paymentType) {
        this.$error(i18n.t("payments.error_choose_payment_type"));
      } else {
        if (!this.requisites && this.paymentType === "invoice") {
          this.showRequisitesWindow();
          return;
        }

        this.$store
            .dispatch("payments/store", {
              sait_code: this.selectedSite.sait_code,
              payment_type: this.paymentType,
              groups_payment: this.groupsPayment,
            })
            .then((data) => {
              this.goToUrl(data.url);
            });
      }
    },
    goToUrl(url) {
      window.open(url, "_blank");
    },
    onResize() {
      this.setWrapHeight();
    },
    setWrapHeight() {
      this.$nextTick(() => {
        //console.log(this.$refs["wrap"].getBoundingClientRect())
        let rect = this.$refs["wrap"].getBoundingClientRect();
        if (rect) {
          let bottom = 100;
          if(this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'){
            bottom=this.$refs['payBlock'].clientHeight+20;
          }
          this.wrapHeight = window.innerHeight - rect.top - bottom;
        }
      });
    },
    calcPrices() {
      this.totalSum = 0;
      this.clientCatalogGroups.forEach((clientCatalogGroup) => {
        this.groupsPayment[clientCatalogGroup.group_id].sum = 0;
        this.groupsPayment[clientCatalogGroup.group_id].number_of_months = 0;
        if(this.groupsPayment[clientCatalogGroup.group_id].is_enabled) {
          this.groupsPayment[clientCatalogGroup.group_id].number_of_months=1;
          this.groupsPayment[clientCatalogGroup.group_id].is_enabled
          let cost_index = "cost_1";
          if (this.$i18n.locale === "en") {
            this.totalCurrency = "eur";
            cost_index = cost_index + "_en";
          } else {
            this.totalCurrency = "rub";
          }

          this.groupsPayment[clientCatalogGroup.group_id].price_per_month = clientCatalogGroup.info[cost_index];


          if( ! this.specialCatalogs.includes(clientCatalogGroup.group_id)){
            this.groupsPayment[clientCatalogGroup.group_id].price_per_month_with_discount = this.groupsPayment[clientCatalogGroup.group_id].price_per_month*this.DISCOUNT_IF_ENABLED_ALL_ORIGINAL_CATALOGS
          } else {
            this.groupsPayment[clientCatalogGroup.group_id].price_per_month_with_discount = this.groupsPayment[clientCatalogGroup.group_id].price_per_month*this.DISCOUNT_IF_ENABLED_ALL_SPECIAL_CATALOGS
          }
          let isOriginal =  ! this.specialCatalogs.includes(clientCatalogGroup.group_id)
          let isSpecial = this.specialCatalogs.includes(clientCatalogGroup.group_id)
          if(isOriginal) {
            this.groupsPayment[clientCatalogGroup.group_id].sum = this.isEnabledAllOriginal ? this.groupsPayment[clientCatalogGroup.group_id].price_per_month_with_discount : this.groupsPayment[clientCatalogGroup.group_id].price_per_month
          }
          if(isSpecial){
            this.groupsPayment[clientCatalogGroup.group_id].sum = this.isEnabledAllSpecial ? this.groupsPayment[clientCatalogGroup.group_id].price_per_month_with_discount : this.groupsPayment[clientCatalogGroup.group_id].price_per_month
          }
        }
        //итоговая сумма для всех групп
        this.totalSum += this.groupsPayment[clientCatalogGroup.group_id].sum;
      });
      this.clientCatalogGroups = [...this.clientCatalogGroups]
    },
  },
};
</script>

<style>
.v-slider__thumb-label {
  z-index: 1000;
}
</style>
